import { render, staticRenderFns } from "./nav-header-search-app.vue?vue&type=template&id=4e264278&"
import script from "./nav-header-search-app.vue?vue&type=script&lang=js&"
export * from "./nav-header-search-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4e264278', component.options)
    } else {
      api.reload('4e264278', component.options)
    }
    module.hot.accept("./nav-header-search-app.vue?vue&type=template&id=4e264278&", function () {
      api.rerender('4e264278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/apps/containers/nav-header-search-app.vue"
export default component.exports